import Component from '@glimmer/component';
import AditoolsMenuLink from './aditools-menu-link.ts';

interface AditoolsMenuLinksSignature {
  Blocks: {
    default: [
      {
        'menu-link': typeof AditoolsMenuLink;
      },
    ];
  };
}

export default class AditoolsMenuLinks extends Component<AditoolsMenuLinksSignature> {
  menuLinkClass = AditoolsMenuLink;
}
